import Vue from 'vue'
import VueRouter from 'vue-router'
import { i18n, normalizeLocale } from '@/main';
import { mergeLivenessRouteQuery } from '@/utils/routeSession';
import { installExpectedNavigationFailureHandling } from '@/utils/routerNavigation';

Vue.use(VueRouter)
installExpectedNavigationFailureHandling(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home/Home.vue')
  },
  {
    path: '/face',
    name: 'face',
    component: () => import('../views/Face/Face.vue')
  },
  {
    path: '/ColorfulFace',
    name: 'ColorfulFace',
    component: () => import('../views/ColorfulFace/ColorfulFace.vue')
  },
  {
    path: '/faceresult',
    name: 'faceresult',
    component: () => import('../views/FaceResult/FaceResult.vue'),
  },
  {
    path: '/RGBFaceResult',
    name: 'RGBFaceResult',
    component: () => import('../views/RGBFaceResult/RGBFaceResult.vue'),
  }, {
    path: '/faceFailed',
    name: 'faceFailed',
    component: () => import('../views/FaceFailed/index.vue'),
  }, {
    path: '/sessionUnavailable',
    name: 'sessionUnavailable',
    component: () => import('../views/SessionUnavailable/SessionUnavailable.vue'),
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
    const mergedQuery = mergeLivenessRouteQuery(to, from)
    const needsRedirect = Object.keys(mergedQuery).some(
      key => !Object.prototype.hasOwnProperty.call(to.query, key)
    )
    const requestedLocale = normalizeLocale(mergedQuery.language)
    if (requestedLocale) i18n.locale = requestedLocale

    // next()
    if (to.fullPath === from.fullPath) {
      return next();
    }
  
    // 如果没有查询参数并且路径不同，重定向并保留参数
    if (needsRedirect) {
   
      next({
        path: to.path,
        query: mergedQuery,
        replace: true,
      });
    } else {

      // 正常导航
      next();
    }
});
  
export default router
